// server.js
const SERVER_API_URL = 'https://api.globel.co.in'; 
// const SERVER_URL = 'http://localhost:3001'; 
// const SERVER_API_URL = 'http://localhost:8000'; 
const SERVER_URL = 'https://globel.co.in'; 

export { SERVER_API_URL, SERVER_URL };